import { render, staticRenderFns } from "./AccountTransactionsComponent.vue?vue&type=template&id=2f8f0d24&"
import script from "./AccountTransactionsComponent.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AccountTransactionsComponent.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VDivider,VIcon})
